import React, { Component } from 'react';
import Toolbar from '../toolbar/Toolbar'
import upload from '../upload.svg';
import './Frame.css';


class Frame extends Component {
  constructor () {
    super();
    this.state = {
      originalImg: null,
      editedImg: null,
      grayscale: 0,
      rotation: 0
    }

    this.loadImage = this.loadImage.bind(this);
    this.handleLeftRotate = this.handleLeftRotate.bind(this);
    this.handleRightRotate = this.handleRightRotate.bind(this);
    this.handleGrayscale = this.handleGrayscale.bind(this);
    this.handleReset = this.handleReset.bind(this);
  }

  loadImage = function (img) {
    if (!img) return;
    let reader = new FileReader();
    reader.onload = (img) => {
      this.setState({
        originalImg: img.target.result,
        editedImg: img.target.result
      })
    };
    reader.readAsDataURL(img);
  }

  handleLeftRotate = function () {
    if (!this.state.originalImg) return;
    this.setState({
      rotation: this.state.rotation + 90
    })
    console.log(this.state.rotation);
  }

  handleRightRotate = function () {
    if (!this.state.originalImg) return;
    this.setState({
      rotation: this.state.rotation - 90
    })
    console.log(this.state.rotation);
  }

  handleGrayscale = function (e, value) {
    if (!this.state.originalImg) return;
    this.setState({
      grayscale: value
    })
  }

  handleReset = function () {
    if (!this.state.originalImg) return;
    this.setState({
      editedImg: this.state.originalImg,
      grayscale: 0,
      rotation: 0
    })
  }

  render() {
    const grayscale = 'grayscale(' + this.state.grayscale + ')';
    const rotation = 'rotate(' + this.state.rotation + 'deg)';
    return(
      <div>
        <div className='frame row'>
        {this.state.originalImg ?
          <img
            className='frame-img'
            src={this.state.editedImg}
            alt='Edit'
            style={{filter: grayscale, transform: rotation}} /> :
          <img
            src={upload}
            alt='Upload' />
        }
        </div>
        <Toolbar
          originalImg={this.state.originalImg}
          grayscale={this.state.grayscale}
          rotation={this.state.rotation}
          loadImage={this.loadImage}
          leftRotate={this.handleLeftRotate}
          rightRotate={this.handleRightRotate}
          makeGray={this.handleGrayscale}
          reset={this.handleReset}/>
      </div>
    );
  }
}

export default Frame;



// WEBPACK FOOTER //
// ./src/frame/Frame.js